import { FaFileContract, FaFileInvoiceDollar } from "react-icons/fa";
import { RoleEnum } from "@/enum/role";
import { GroupsEnum } from "@/enum/groups";
import GenerateTermRoutes from "@/pages/store-back-office/generate-term/generate-term.routes";
import { BalanceCashRequestRoutes } from "@/pages/store-back-office/balance-cash/balance-cash-request.routes";
import { Users2Icon } from "lucide-react";
import BackOfficeAccessRequestRoutes from "@/pages/store-back-office/access-request/access-request.routes";
import { createRoute } from "../createRoute";
import { PATH_IDS } from "../path-ids";

export const storeBackOfficeRoutes = [
  createRoute({
    id: "Requisições de Acesso",
    category: "Acessos",
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.RETAGUARDA_DE_LOJA],
    path: "/requisicao-de-acesso/*",
    pathId: PATH_IDS.RETAGUARDA_DE_LOJA,
    element: <BackOfficeAccessRequestRoutes />,
    Icon: Users2Icon,
  }),
  createRoute({
    id: "Saldo da Loja",
    category: "Tesouraria",
    requiredRole: [RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.RETAGUARDA_DE_LOJA],
    path: "/saldo-da-loja/*",
    pathId: PATH_IDS.RETAGUARDA_DE_LOJA,
    element: <BalanceCashRequestRoutes />,
    Icon: FaFileInvoiceDollar,
  }),
  createRoute({
    id: "Termo de Tesouraria",
    category: "Tesouraria",
    requiredRole: [RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.RETAGUARDA_DE_LOJA],
    path: "/termo-de-tesouraria/*",
    pathId: PATH_IDS.RETAGUARDA_DE_LOJA,
    element: <GenerateTermRoutes />,
    Icon: FaFileContract,
  }),
];
